export enum FileConfig {
  // 10 MiB
  MAX_IMAGE_SIZE_BYTES = 10485760,
  // 512 MiB
  MAX_VIDEO_SIZE_BYTES = 536870912,
  // 3840 x 2160
  PIXEL_LIMIT = 8294400,
}
